import { SetPasswordModel } from '../models/set-password.model';
import { VerifyDto } from '../dtos/verify.dto';

export class AuthenticationMapper {
  static toVerifyDto(setPasswordModel: SetPasswordModel) : VerifyDto {
    return {
      verificationCode: setPasswordModel.verificationCode,
      password: setPasswordModel.password,
    }
  }
}
